import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { TaxFormType } from './taxFormsTypes';

export const getTaxForms = createAction('GET_TAX_FORMS', getPayloadCreator());
export const getTaxFormsSuccess = createAction(
  'GET_TAX_FORMS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<TaxFormType>>(),
);
export const getTaxFormsFailure = createAction('GET_TAX_FORMS_FAILURE', errorPayloadCreator);
